/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} PasteInputs */

const en_paste = /** @type {(inputs: PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste`)
};

const fr_paste = /** @type {(inputs: PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coller`)
};

const de_paste = /** @type {(inputs: PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste`)
};

const it_paste = /** @type {(inputs: PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impasto`)
};

const ru_paste = /** @type {(inputs: PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставить`)
};

const es_paste = /** @type {(inputs: PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasta`)
};

const zh_cn2_paste = /** @type {(inputs: PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴`)
};

const ja_paste = /** @type {(inputs: PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ペースト`)
};

const hi_paste = /** @type {(inputs: PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पेस्ट करें`)
};

const pt_pt2_paste = /** @type {(inputs: PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colar`)
};

/**
* | output |
* | --- |
* | "Paste" |
*
* @param {PasteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const paste = /** @type {((inputs?: PasteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<PasteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_paste(inputs)
	if (locale === "de") return de_paste(inputs)
	if (locale === "it") return it_paste(inputs)
	if (locale === "ru") return ru_paste(inputs)
	if (locale === "es") return es_paste(inputs)
	if (locale === "zh-CN") return zh_cn2_paste(inputs)
	if (locale === "ja") return ja_paste(inputs)
	if (locale === "hi") return hi_paste(inputs)
	if (locale === "pt-PT") return pt_pt2_paste(inputs)
	return en_paste(inputs)
});